var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 31",
    style: {
      enableBackground: "new 0 0 32 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "person_00000048467861449854866750000001332603434860318101_",
    gradientUnits: "userSpaceOnUse",
    x1: -506.1585,
    y1: 540.16,
    x2: -506.1585,
    y2: 539.16,
    gradientTransform: "matrix(32.0045 0 0 -31.057 16215.3359 16775.7441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9E021"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "person",
    style: {
      fill: "url(#person_00000048467861449854866750000001332603434860318101_)"
    },
    d: "M16,15 c-4,0.2-7.3-2.9-7.5-6.9c0-0.2,0-0.4,0-0.6c-0.2-4,2.9-7.3,6.9-7.5c0.2,0,0.4,0,0.6,0c4-0.2,7.3,2.9,7.5,6.9c0,0.2,0,0.4,0,0.6 c0.2,4-2.9,7.3-6.9,7.5C16.4,15,16.2,15,16,15z M29,31H3c-1.7,0-3-1.3-3-3c0,0,0,0,0,0v-1.7c0-1.2,0.3-2.3,0.9-3.2 c0.6-0.9,1.5-1.6,2.4-2c2.1-0.9,4.2-1.7,6.4-2.2c2-0.5,4.1-0.7,6.2-0.8c2.1,0,4.1,0.3,6.1,0.8c2.2,0.6,4.3,1.3,6.4,2.2 c1,0.4,1.9,1.2,2.5,2c0.7,1,1,2.1,1,3.2V28C32,29.7,30.7,31,29,31C29,31.1,29,31.1,29,31z M3,28h26v-1.7c0-0.5-0.2-1.1-0.5-1.5 c-0.3-0.5-0.7-0.8-1.2-1.1c-1.9-0.9-3.8-1.6-5.9-2.1C19.7,21.2,17.8,21,16,21c-1.9,0-3.7,0.2-5.5,0.6c-2,0.5-4,1.2-5.9,2.1 c-1,0.5-1.6,1.5-1.6,2.6V28z M16,12c2.4,0.1,4.4-1.8,4.5-4.2c0-0.1,0-0.2,0-0.3c0.1-2.4-1.8-4.4-4.2-4.5c-0.1,0-0.2,0-0.3,0 c-2.4-0.1-4.4,1.8-4.5,4.2c0,0.1,0,0.2,0,0.3c-0.1,2.4,1.8,4.4,4.2,4.5C15.8,12,15.9,12,16,12z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGreen);
export default __webpack_public_path__ + "static/media/profile_green.ad942947125d2e01f2d53339160f5e07.svg";
export { ForwardRef as ReactComponent };